import { MAX_STORES_LIST } from "../storeSearch.config";
import { enrichStores } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";

export const findStoresByTags = async (
    StoresService: woosmap.map.StoresService,
    storeUrls: Array<StoreUrl>,
    tags: Array<string>,
    locale: string,
) => {
    const query = [
        `user.locale:="${locale}"`,
        ...tags.map(tag => `tag:"${tag}"`),
    ].join(" AND ");

    const storesResponse = await StoresService.search({
        query: query,
        storesByPage: MAX_STORES_LIST,
    });

    const stores = enrichStores(storesResponse.features ?? [], storeUrls);

    return {
        stores: stores,
        query: query,
    };
};
